import ActiveLoans from "./routes/active-loans";
import Borrowers from "./routes/borrowers";
import DefaultedLoans from "./routes/defaulted-loans";
import Overview from "./routes/overview";
import CoolerV2 from "./routes/cooler-v2";
import { Welcome } from "./welcome/welcome";
import { HashRouter, Link, Route, Routes, useLocation } from "react-router";

// New navigation component
function Navigation() {
  const location = useLocation();
  
  const getPageTitle = () => {
    switch (location.pathname) {
      case "/":
        return "Overview";
      case "/cooler-v1":
        return "Cooler V1";
      case "/cooler-v2":
        return "Cooler V2";
      case "/active-loans":
        return "Active Loans (v1)";
      case "/defaulted-loans":
        return "Defaulted Loans (v1)";
      case "/borrowers":
        return "Borrowers (v1)";
      case "/protocol-income":
        return "Protocol Income";
      default:
        return "Overview";
    }
  };

  const isV1Page = ["/active-loans", "/defaulted-loans", "/borrowers", "/cooler-v1"].includes(location.pathname);
  const isV2Page = location.pathname === "/cooler-v2";
  const isOverviewPage = location.pathname === "/";

  return (
    <div className="mb-6">
      <div className="flex items-center justify-between mb-4">
        <Link to="/">
          <img src="/logo.svg" alt="logo" width="200px" />
        </Link>
        <div className="flex space-x-4">
          <Link 
            to="/" 
            className={`px-4 py-2 rounded-md transition-colors ${
              isOverviewPage ? 'underline decoration-[#f8cc82] decoration-2 underline-offset-8' : 'hover:underline hover:decoration-white hover:decoration-2 hover:underline-offset-8'
            }`}
          >
            Overview
          </Link>
          <Link 
            to="/cooler-v1" 
            className={`px-4 py-2 rounded-md transition-colors ${
              isV1Page ? 'underline decoration-[#f8cc82] decoration-2 underline-offset-8' : 'hover:underline hover:decoration-white hover:decoration-2 hover:underline-offset-8'
            }`}
          >
            Cooler V1
          </Link>
          <Link 
            to="/cooler-v2" 
            className={`px-4 py-2 rounded-md transition-colors ${
              isV2Page ? 'underline decoration-[#f8cc82] decoration-2 underline-offset-8' : 'hover:underline hover:decoration-white hover:decoration-2 hover:underline-offset-8'
            }`}
          >
            Cooler V2
          </Link>
        </div>
      </div>
      
      <div className="flex items-center space-x-2 text-sm text-muted-foreground mb-2">
        <Link to="/" className="hover:text-foreground">Home</Link>
        {location.pathname !== "/" && (
          <>
            <span>/</span>
            <span className="text-foreground">{getPageTitle()}</span>
          </>
        )}
      </div>
      
      <h1 className="text-3xl font-bold mb-2">Cooler Metrics</h1>
      <h2 className="text-xl text-muted-foreground">{getPageTitle()}</h2>
    </div>
  );
}

export default function App() {
  return (
    <div className="min-h-screen bg-background">
      <HashRouter>
        <div className="container mx-auto">
          <div className="my-8">
            <Navigation />
            <Routes>
              <Route path="/" element={<Overview />} />
              <Route path="/cooler-v1" element={<Welcome />} />
              <Route path="/cooler-v2" element={<CoolerV2 />} />
              <Route path="/defaulted-loans" element={<DefaultedLoans />} />
              <Route path="/borrowers" element={<Borrowers />} />
              <Route path="/active-loans" element={<ActiveLoans />} />
            </Routes>
          </div>
        </div>
      </HashRouter>
    </div>
  );
}
